/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarrierVisitDirection } from '../model';
// @ts-ignore
import type { CreateGeneralCargoOrderCommand } from '../model';
// @ts-ignore
import type { OrderResponseDto } from '../model';
// @ts-ignore
import type { UpdateGeneralCargoOrderCommand } from '../model';
/**
 * GeneralCargoApi - axios parameter creator
 */
export const GeneralCargoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/GeneralCargo/All`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerOrReferenceNumber: async (filter?: string, direction?: CarrierVisitDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/GeneralCargo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateGeneralCargoOrderCommand} [createGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post: async (createGeneralCargoOrderCommand?: CreateGeneralCargoOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/GeneralCargo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGeneralCargoOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateGeneralCargoOrderCommand>} [createGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulk: async (createGeneralCargoOrderCommand?: Array<CreateGeneralCargoOrderCommand>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/GeneralCargo/Bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGeneralCargoOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateGeneralCargoOrderCommand} [updateGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (id: number, updateGeneralCargoOrderCommand?: UpdateGeneralCargoOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('put', 'id', id)
            const localVarPath = `/planning/api/GeneralCargo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGeneralCargoOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralCargoApi - functional programming interface
 */
export const GeneralCargoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralCargoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerOrReferenceNumber(filter?: string, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerOrReferenceNumber(filter, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoApi.getByCustomerOrReferenceNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateGeneralCargoOrderCommand} [createGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async post(createGeneralCargoOrderCommand?: CreateGeneralCargoOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.post(createGeneralCargoOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoApi.post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CreateGeneralCargoOrderCommand>} [createGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBulk(createGeneralCargoOrderCommand?: Array<CreateGeneralCargoOrderCommand>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBulk(createGeneralCargoOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoApi.postBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateGeneralCargoOrderCommand} [updateGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(id: number, updateGeneralCargoOrderCommand?: UpdateGeneralCargoOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(id, updateGeneralCargoOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralCargoApi - factory interface
 */
export const GeneralCargoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralCargoApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerOrReferenceNumber(filter?: string, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.getByCustomerOrReferenceNumber(filter, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateGeneralCargoOrderCommand} [createGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(createGeneralCargoOrderCommand?: CreateGeneralCargoOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.post(createGeneralCargoOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<CreateGeneralCargoOrderCommand>} [createGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulk(createGeneralCargoOrderCommand?: Array<CreateGeneralCargoOrderCommand>, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.postBulk(createGeneralCargoOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateGeneralCargoOrderCommand} [updateGeneralCargoOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(id: number, updateGeneralCargoOrderCommand?: UpdateGeneralCargoOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.put(id, updateGeneralCargoOrderCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeneralCargoApi - object-oriented interface
 */
export class GeneralCargoApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAll(options?: RawAxiosRequestConfig) {
        return GeneralCargoApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {CarrierVisitDirection} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByCustomerOrReferenceNumber(filter?: string, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig) {
        return GeneralCargoApiFp(this.configuration).getByCustomerOrReferenceNumber(filter, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateGeneralCargoOrderCommand} [createGeneralCargoOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public post(createGeneralCargoOrderCommand?: CreateGeneralCargoOrderCommand, options?: RawAxiosRequestConfig) {
        return GeneralCargoApiFp(this.configuration).post(createGeneralCargoOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<CreateGeneralCargoOrderCommand>} [createGeneralCargoOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postBulk(createGeneralCargoOrderCommand?: Array<CreateGeneralCargoOrderCommand>, options?: RawAxiosRequestConfig) {
        return GeneralCargoApiFp(this.configuration).postBulk(createGeneralCargoOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateGeneralCargoOrderCommand} [updateGeneralCargoOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public put(id: number, updateGeneralCargoOrderCommand?: UpdateGeneralCargoOrderCommand, options?: RawAxiosRequestConfig) {
        return GeneralCargoApiFp(this.configuration).put(id, updateGeneralCargoOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

